import { createSelector } from '@reduxjs/toolkit';
import { ProductType } from '@yme/common/constants';
import { getAttributes, getProductDetails } from '@yme/selectors/products';
import { DISCLAIMER, PRODUCT_DISCLAIMER } from './constants';
const getProductDisclaimer = (attr, type) => attr.name === (type === ProductType.UNIT ? PRODUCT_DISCLAIMER : DISCLAIMER);
export const getProductDisclaimerValue = createSelector(getProductDetails, getAttributes, ({ data }, attributes) => {
    const productDisclaimerData = attributes.find((item) => getProductDisclaimer(item, data?.type));
    return productDisclaimerData?.value || '';
});
